// src/components/TileGrid.jsx
import React from 'react';
import Tile from './Tile';
import './TileGrid.css';

export default function TileGrid({ tiles, className = '' }) {
  // App Store compliance: the release dashboard must not expose the medication
  // calculator. The standalone/internal web calculator code remains available for
  // its separate authorized workflow, but there is no member-dashboard entry point.
  const visibleTiles = tiles.filter(tile => tile?.id !== 'drug-calculator');

  return (
    <div className={`tile-grid ${className}`.trim()}>
      {visibleTiles.map((tile, index) => (
        <Tile
          key={tile.id || tile.title || index}
          title={tile.title}
          description={tile.description}
          href={tile.href}
          logo={tile.logo}
          icon={tile.icon}
          variant={tile.variant}
          onClick={tile.onClick}
        />
      ))}
    </div>
  );
}
